import { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth, getLandingRoute } from '../hooks/useAuth'

export default function SellerLoginPage() {
  const { user, login, loading } = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (user) {
      if (user.role === 'admin') {
        navigate('/login/admin')
      } else {
        navigate(getLandingRoute(user))
      }
    }
  }, [user, navigate])

  if (loading) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center bg-cream-100">
        <div className="text-xl text-espresso-600">Cargando...</div>
      </div>
    )
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    if (!email.trim()) {
      setError('Por favor ingresa tu correo')
      return
    }
    if (!password) {
      setError('Por favor ingresa tu contraseña')
      return
    }
    setSubmitting(true)
    try {
      await login(email.trim().toLowerCase(), password)
    } catch (err: any) {
      setError(err.message || 'Error al iniciar sesión. Por favor intenta de nuevo.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-cream-100">
      <div className="max-w-md w-full space-y-8 p-8 bg-cream-50 rounded-lg shadow-md">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-terracotta-700">☕ Cafe Distribution</h1>
          <p className="mt-2 text-espresso-600">Inicio de Sesión - Colaborador</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-espresso-700 mb-1">
              Correo Electrónico
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@ejemplo.com"
              className="w-full px-3 py-2 border border-espresso-200 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-terracotta-500 focus:border-terracotta-500"
              autoFocus
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-espresso-700 mb-1">
              Contraseña
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingresa tu contraseña"
              className="w-full px-3 py-2 border border-espresso-200 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-terracotta-500 focus:border-terracotta-500"
            />
          </div>
          {error && (
            <p className="text-sm text-red-600">{error}</p>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="w-full py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-terracotta-600 hover:bg-terracotta-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-terracotta-500 disabled:opacity-50"
          >
            {submitting ? 'Iniciando sesión...' : 'Iniciar como Colaborador'}
          </button>
        </form>
        <div className="text-center mt-4 space-y-2">
          <p className="text-sm text-espresso-600">
            ¿No tienes una cuenta?{' '}
            <Link to="/register/seller" className="text-terracotta-700 hover:text-terracotta-800">
              Registrarse como Colaborador
            </Link>
          </p>
          <Link to="/forgot-password" className="text-sm text-terracotta-700 hover:text-terracotta-800 block">
            ¿Olvidaste tu contraseña?
          </Link>
          <p className="text-xs text-espresso-500">
            Contacta a tu administrador para obtener credenciales de acceso
          </p>
        </div>
      </div>
    </div>
  )
}
